export const propertySelectionInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: true };

    // ToDo: add required checks
    if (campaign.hasQuotes) {
        state.stepCompleted = true;
        state.stepEdited = true;
    }

    return state;
};
